import styled from "styled-components";

export const JBOptInReminderHeader777Box = styled.div`
    display: flex; 
    flex-direction: column; 
    align-items: center;
    background: #FFD68333;
    height: 106px;
    width: 100%;
    justify-content: center;
`;


